module.exports = __webpack_public_path__ + "static/media/harrington-hollow.758f19ae.jpg";